import { readonly, ref, shallowRef } from 'vue';

import type { PaymentEditPayload } from '@celerdata/host-bridge-contract';

// Singleton dialog state shared by every caller — the wujie bridge
// listener and any future native /billing view. Module-scope refs are
// intentional: only one PaymentEditDialog exists per page, so callers
// don't need to thread state through props or provide/inject.

const isOpen = ref(false);
const payload = shallowRef<PaymentEditPayload | null>(null);

export function usePaymentEditDialog() {
  return {
    isOpen: readonly(isOpen),
    payload: readonly(payload),
    open(next: PaymentEditPayload): void {
      payload.value = next;
      isOpen.value = true;
    },
    // `close()` only flips the visibility flag; ElDialog's close
    // animation reads title/label bindings for another ~200ms after
    // isOpen goes false, and clearing `payload` here would flash the
    // title to the "Add" fallback mid-fade. Call `dispose()` from
    // ElDialog's `@closed` event once the animation has settled.
    close(): void {
      isOpen.value = false;
    },
    dispose(): void {
      payload.value = null;
    },
  };
}
